import { Trans } from '@lingui/react/macro'
import { EntryLayout } from '../components/Layout/EntryLayout'
import { LoginPage, restartLoginUrl } from './LoginPage'
import { useParams, useSearchParams } from 'react-router-dom'
import { Redirect } from '@jotta/ui/Redirect'
import { ErrorMessage } from '@jotta/ui/ErrorMessage'

function LoginError({ error }: { error: string }) {
  return (
    <div className="flex flex-col gap-4">
      <ErrorMessage error={error} />
      <a className="btn btn-primary" href={restartLoginUrl}>
        <Trans>Restart login</Trans>
      </a>
    </div>
  )
}

export function LoginRoute() {
  const { loginToken } = useParams()
  const [searchParams] = useSearchParams()
  const error = searchParams.get('error')

  return (
    <EntryLayout>
      {error ? (
        <LoginError error={error} />
      ) : loginToken ? (
        <LoginPage loginToken={loginToken} />
      ) : (
        <Redirect to={restartLoginUrl} reload replace />
      )}
    </EntryLayout>
  )
}
